// ============================================================
// Tour Expense System — Utility Functions
// ============================================================

export function generateId() {
  return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
}

export function formatCurrency(amount) {
  if (amount === null || amount === undefined || isNaN(amount)) return '₹0.00';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency', currency: 'INR',
    minimumFractionDigits: 2, maximumFractionDigits: 2,
  }).format(amount);
}

export function formatCurrencyShort(amount) {
  if (Math.abs(amount) >= 1000) {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency', currency: 'INR',
      minimumFractionDigits: 0, maximumFractionDigits: 0,
    }).format(amount);
  }
  return formatCurrency(amount);
}

export function formatDate(dateStr) {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function formatDateShort(dateStr) {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' });
}

export function today() {
  return new Date().toISOString().split('T')[0];
}

export const CATEGORIES = {
  accommodation: { label: 'Accommodation', icon: '🏨', color: '#3b82f6' },
  food:          { label: 'Food & Dining', icon: '🍽️', color: '#f59e0b' },
  transport:     { label: 'Transport',     icon: '🚗', color: '#8b5cf6' },
  entertainment: { label: 'Entertainment', icon: '🎢', color: '#ec4899' },
  shopping:      { label: 'Shopping',      icon: '🛍️', color: '#14b8a6' },
  misc:          { label: 'Miscellaneous', icon: '📦', color: '#6b7280' },
};

export function getCategory(key) {
  return CATEGORIES[key] || CATEGORIES.misc;
}

export function getAllCategoryKeys() {
  return Object.keys(CATEGORIES);
}

export function getInitials(name = '') {
  return name.split(' ').map(w => w[0]).join('').toUpperCase().substring(0, 2);
}

export function getFamilyColor(familyId) {
  return familyId === 'family1'
    ? { bg: 'rgba(16,185,129,0.15)', border: '#10b981', text: '#34d399' }
    : { bg: 'rgba(59,130,246,0.15)', border: '#3b82f6', text: '#60a5fa' };
}

export function validateExpense(data) {
  const errors = [];
  if (!data.date) errors.push('Date is required');
  if (!data.amount || data.amount <= 0) errors.push('Amount must be greater than 0');
  if (!data.description?.trim()) errors.push('Description is required');
  if (!data.category) errors.push('Category is required');
  if (!data.paidBy) errors.push('Please select who paid');
  if (!data.splitType) errors.push('Split type is required');
  if (data.splitType === 'custom') {
    const s1 = parseFloat(data.family1Share) || 0;
    const s2 = parseFloat(data.family2Share) || 0;
    const total = parseFloat(data.amount) || 0;
    if (Math.abs(s1 + s2 - total) > 0.01) {
      errors.push('Custom shares must add up to the total amount');
    }
  }
  return errors;
}
